import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid2 } from '@mui/material'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import React, { useState, useEffect } from 'react';
import { myApi } from '../../../../config/axiosConfig';
import Swal from 'sweetalert2';

// COMPONENTES
import MyTextInput from '../../../../components/inputs/MyTextInput';

const EditarTractor = ({ open, onClose, refresh, data }) => {

    // ===========================================
    // ESTADO PARA FORMULARIO
    // ===========================================

    const [formValues, setFormValues] = useState({});

    // ===========================================
    // USE EFFECT PARA LLAMAR DATOS
    // ===========================================

    useEffect(() => {

        setFormValues(data);

    }, [data]);

    // ===========================================
    // FUNCION PARA SUBMIT DEL FORMULARIO
    // ===========================================

    const submitForm = async ( values ) => {

        try {

            const response = await myApi.put('/tractores/update', values);

            if(response.data.success){

                onClose();

                Swal.fire({
                    icon: response.data.icon,
                    title: response.data.message,
                });

                refresh();

            }



        } catch (error) {

            console.log(error);

        }

    }

    // ===========================================

    return (

        <Dialog 
            open={open} 
            onClose={onClose} 
            fullWidth 
            maxWidth="xs"
        >

            <DialogTitle>Editar Tractor {data?.tractor}</DialogTitle>

            <DialogContent sx={{ padding: 2 }}>

                <Formik
                    initialValues={formValues}
                    enableReinitialize={true}
                    validationSchema={Yup.object({
                            make: Yup.string().required('Marca Obligatoria'),
                            mcleod_placas: Yup.string().required('Placas Obligatorias'),
                            mcleod_placas_mx: Yup.string().required('Placas Obligatorias'),
                        })}
                    onSubmit={submitForm}
                >
                    {({ isSubmitting }) => (

                        <Form style={{ width: '100%' }}>

                            <Grid2 container spacing={2}>

                                {/* MARCA */}

                                <Grid2 size={12}>

                                    <MyTextInput
                                        name="make"
                                        label="Marca"
                                    />

                                </Grid2>

                                {/* PLACAS USA */}

                                <Grid2 size={12}>

                                    <MyTextInput
                                        name="mcleod_placas"
                                        label="Placas USA"
                                    />

                                </Grid2>

                                {/* PLACAS MX */}

                                <Grid2 size={12}>

                                    <MyTextInput
                                        name="mcleod_placas_mx"
                                        label="Placas MX"
                                    />

                                </Grid2>

                                <DialogActions sx={{ justifyContent: 'flex-end' }}>

                                    <Button 
                                        type="submit" 
                                        variant="contained" 
                                        color="primary"
                                        disabled={isSubmitting}
                                    >
                                        Guardar
                                    </Button>

                                    <Button onClick={onClose}>Cancelar</Button>

                                </DialogActions>

                            </Grid2>

                        </Form>

                    )}

                </Formik>

            </DialogContent>

        </Dialog>

    )

}

export default EditarTractor